export type HexUnit = 'nominal' | 'perSqft';

export function MapUnitToggle({
  unit,
  onChange,
}: {
  unit: HexUnit;
  onChange: (unit: HexUnit) => void;
}) {
  return (
    <div className="map-layer-toggle" role="group" aria-label="Price unit">
      <button
        type="button"
        aria-pressed={unit === 'nominal'}
        onClick={() => onChange('nominal')}
      >
        Nominal
      </button>
      <button
        type="button"
        aria-pressed={unit === 'perSqft'}
        onClick={() => onChange('perSqft')}
      >
        Per sq ft
      </button>
    </div>
  );
}
